module.exports = __webpack_public_path__ + "static/media/bg5.41b88cc2.jpg";